<!-- Pending to test this item-->
<template>
  <b-form-radio
    class="al-form-radio"
    :value="value"
    :checked="checked"
    :name="name"
    :disabled="disabled"
    :class="{ selected: checked === value }"
    test-id="al-form-radio"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <slot />
  </b-form-radio>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue';

export default {
  components: {
    BFormRadio
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    value: {
      type: [Object, String, Array, Number, Boolean],
      default: ''
    },
    checked: {
      type: [Object, String, Array, Number, Boolean],
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    disabled: Boolean
  }
};
</script>

<style lang="scss">
.al-form-radio {
  * {
    cursor: pointer;
  }
}
</style>
